<template>
  <div class="newsletter relative py-6 wide-bg-EXPONDO-secondary">
    <div class="relative px-6 lg:px-10 text-left lg:pt-0 lg:flex lg:justify-center">
      <div class="lg:w-3/5 lg:pr-5">
        <NewsletterForm
          input-id="newsletter-footer-signup-input"
          :signup-button-text="$t('Sign Up')"
          form-classes="max-w-xs relative mt-7 lg:mx-0 lg:mt-5"
          @subscription-progress-update="onSubscriptionProgressUpdated"
        >
          <template #loading>
            <FooterNewsletterFormSkeleton />
          </template>

          <template #header>
            <p class="text-EXPONDO-white text-xl font-bold uppercase w-2/3 lg:w-auto">
              {{ $t("Newsletter Title") }}
            </p>
            <p class="text-EXPONDO-grey-5 mt-4">
              {{ $t("Newsletter Subtitle") }}
            </p>
          </template>

          <template #error-details="{ error }">
            <p class="text-EXPONDO-grey-5 mt-2 lg:mt-7">
              {{ error }}
            </p>
          </template>

          <template #newsletter-error>
            <p class="text-EXPONDO-grey-5 mt-2 lg:mt-7">
              {{ $t("newsletterError") }}
            </p>
          </template>

          <template #privacy>
            <p class="text-EXPONDO-grey-5 mt-2 lg:mt-7">
              <span class="mr-1">{{ $t("Newsletter Disclaimer") }}</span>
              <SimpleLink
                class="underline text-EXPONDO-white hover:text-EXPONDO-grey-5"
                :to="newsletterLink"
              >
                {{ $t("Newsletter Privacy Policy") }}
              </SimpleLink>.
              <span>{{ $t("Newsletter Disclaimer 2") }}</span>
            </p>
          </template>
          <template #thank-you>
            <p class="pt-6 text-EXPONDO-white max-w-lg lg:max-w-none lg:mt-8 text-xl font-bold">
              {{ $t("Newsletter Thank You") }}
            </p>
          </template>
        </NewsletterForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { ROUTES } from '~~/constants/routes';
import type { NewsletterSubscriptionData } from '~~/types/product/NewsletterSubscriptionData';

export default defineComponent({
  name: 'NewsletterWrapper',
  emits: ['newsletter-consent'],

  setup(_props, { emit }) {

    const { getAdjustedSlug } = useRouteExtended();
    const newsletterLink = computed(() => getAdjustedSlug(ROUTES.PRIVACY));

    const onSubscriptionProgressUpdated = (value: NewsletterSubscriptionData) => {

      emit('newsletter-consent', value?.newsletterConsent);

    };

    return {
      newsletterLink,
      onSubscriptionProgressUpdated,
    };

  },
});

</script>
